<template>
  <div>
      <Showrequets />
  </div>
</template>

<script>
import Showrequets from '../../../components/academic/Advisor/showrequets.vue'

export default {
    
components:{
    Showrequets
}
}
</script>

<style>

</style>